import { useState } from 'react';
import WhatsAppIcon from '../../components/WhatsAppIcon';

const WA_URL =
  "https://wa.me/5511986304696?text=Ol%C3%A1!%20Vim%20pelo%20site%20da%20l'ora%20e%20gostaria%20de%20conhecer%20mais%20sobre%20a%20ag%C3%AAncia.";

const VALUES = [
  {
    num: '01',
    title: 'Criatividade com propósito',
    desc: 'Toda ideia precisa ter intenção. Criamos pensando no que a marca quer comunicar e em como fazer isso acontecer.',
  },
  {
    num: '02',
    title: 'Autenticidade',
    desc: 'Cada marca tem sua própria identidade. Nosso trabalho é encontrar a melhor forma de expressá-la, sem fórmulas prontas.',
  },
  {
    num: '03',
    title: 'Olhar atento',
    desc: 'Acreditamos na força dos detalhes, das imagens e das histórias que merecem ser contadas e lembradas.',
  },
  {
    num: '04',
    title: 'Estratégia e intenção',
    desc: 'Beleza importa, mas precisa caminhar junto com um objetivo. Criamos para comunicar, posicionar e aproximar marcas de pessoas.',
  },
  {
    num: '05',
    title: 'Parceria de verdade',
    desc: 'Gostamos de construir junto, ouvir, trocar ideias e entender o que cada cliente precisa.',
  },
  {
    num: '06',
    title: 'Compromisso',
    desc: 'Valorizamos a responsabilidade, a transparência e o cuidado em cada etapa do trabalho.',
  },
];

export default function About() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="section wrap about-section" id="sobre">
      {/* ── 9. Sobre a l’ora ── */}
      <div className="about-hero">
        <div className="eyebrow">Institucional</div>
        <h2>
          Marcas também<br />
          têm <em>histórias.</em>
        </h2>
        <div className="about-lead">
          <p>
            A <strong>l’ora</strong> transforma ideias em comunicação, conteúdo e imagens
            que mostram o que cada marca tem de especial.
          </p>
          <p className="highlight">
            Porque não basta estar presente: sua marca precisa ser reconhecida e lembrada.
          </p>
        </div>
      </div>

      {/* ── 10. Missão, Visão e Valores ── */}
      <div className="mvv-grid">
        {/* Missão */}
        <article className="mvv-card">
          <div className="mvv-header">
            <span className="eyebrow">Propósito</span>
            <h3>Missão</h3>
          </div>
          <p>
            Transformar ideias em comunicação que faz sentido. Unimos estratégia, criatividade
            e audiovisual para ajudar marcas a contarem suas histórias, mostrarem seu valor e
            criarem conexões reais com as pessoas.
          </p>
        </article>

        {/* Visão */}
        <article className="mvv-card">
          <div className="mvv-header">
            <span className="eyebrow">Futuro</span>
            <h3>Visão</h3>
          </div>
          <p>
            Ser uma agência reconhecida pelo olhar criativo, pela qualidade do que produz e
            pela forma como transforma ideias em projetos que marcam. Crescer sem perder nossa
            essência e construir relações duradouras com marcas que acreditam no nosso trabalho.
          </p>
        </article>
      </div>

      {/* Valores — Accordion / Cards */}
      <div className="values-container">
        <div className="values-header">
          <div className="eyebrow">Diretrizes</div>
          <h3>Nossos Valores</h3>
          <p>Princípios que guiam cada decisão, criação e entrega da l’ora.</p>
        </div>

        <div className="values-list">
          {VALUES.map((val, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={val.num}
                className={`value-item ${isOpen ? 'open' : ''}`}
                onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setOpenIndex(isOpen ? -1 : idx);
                  }
                }}
                aria-expanded={isOpen}
              >
                <div className="value-item-head">
                  <div className="value-title-wrap">
                    <span className="value-num">{val.num}</span>
                    <h4>{val.title}</h4>
                  </div>
                  <span className="value-toggle">{isOpen ? '−' : '+'}</span>
                </div>
                {isOpen && <p className="value-desc">{val.desc}</p>}
              </div>
            );
          })}
        </div>
      </div>

      <div className="about-footer-cta">
        <a className="link" href={WA_URL} target="_blank" rel="noopener noreferrer">
          <WhatsAppIcon />
          <span>
            Construir uma história com a l’ora
            <span className="arrow" aria-hidden="true">
              →
            </span>
          </span>
        </a>
      </div>
    </section>
  );
}
